import Actions from './action';
export const initState = {
	campaignDDListLoading: false,
	campaignDDList: [],
	addCampaignLoading: false,
};

const affiliateByIDReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.GET_CAMPAIGN_DD_STARTED: {
			return {
				...state,
				campaignDDListLoading: true,
			};
		}
		case Actions.types.GET_CAMPAIGN_DD_STARTED_SUCCESS: {
			return {
				...state,
				campaignDDListLoading: false,
				campaignDDList: action.response,
			};
		}
		case Actions.types.GET_CAMPAIGN_DD_STARTED_FAIL: {
			return {
				...state,
				campaignDDListLoading: false,
				campaignDDList: [],
			};
		}
		case Actions.types.ADD_CAMPAIGN_STARTED: {
			return {
				...state,
				addCampaignLoading: true,
			};
		}
		case Actions.types.ADD_CAMPAIGN_SUCCESS: {
			return {
				...state,
				addCampaignLoading: false,
			};
		}
		case Actions.types.ADD_CAMPAIGN_FAIL: {
			return {
				...state,
				addCampaignLoading: false,
			};
		}

		default:
			return state;
	}
};

export default affiliateByIDReducer;
